import { h } from '../../ui/dom';

/** Square-style text link in a card header ("View orders" → "See all"). */
export const cardLink = (label: string, href: string): HTMLAnchorElement => h('a', { class: 'cardlink', href }, label);
